import { createContext, useContext } from 'react';

// Locale activo (es-AR / es-UY / es-PE). Lo resuelve utils/localeManager por el dominio en
// getServerSideProps y lo provee pages/_app.js.
//
// Para navegar hay que usar este locale, nunca router.locale: en prod el Host que le llega a
// Next no coincide con el dominio configurado, Next resuelve es-AR en .uy/.pe y cualquier
// <Link> o router.push sin `locale` explícito redirige a hopenvios.com.ar.
const LocaleContext = createContext(undefined);

export const useLocale = () => useContext(LocaleContext);

export default LocaleContext;
